import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const initial = { name: "", email: "", contact: "", city: "", requirements: "" };

export default function DiscoveryCallForm() {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.contact || !form.city || !form.requirements) {
      toast.error("Please fill in all fields.");
      return;
    }
    try {
      setLoading(true);
      await api.post("/leads/discovery-call", form);
      toast.success("Request received. Nitin's team will reach out shortly.");
      setForm(initial);
    } catch (err) {
      toast.error("Something went wrong. Please try again or message on WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="discovery-form" className="space-y-7">
      <Field label="Full name" testid="dc-name">
        <input
          data-testid="dc-input-name"
          name="name" value={form.name} onChange={onChange}
          placeholder="Your name"
          className="input-airy w-full bg-transparent border-0 border-b border-stone-300 py-3 text-lg focus:border-terracotta"
        />
      </Field>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
        <Field label="Email" testid="dc-email">
          <input
            data-testid="dc-input-email"
            type="email" name="email" value={form.email} onChange={onChange}
            placeholder="you@email.com"
            className="input-airy w-full bg-transparent border-0 border-b border-stone-300 py-3 text-lg focus:border-terracotta"
          />
        </Field>
        <Field label="WhatsApp / Phone" testid="dc-contact">
          <input
            data-testid="dc-input-contact"
            name="contact" value={form.contact} onChange={onChange}
            placeholder="+91 9XXXXXXXXX"
            className="input-airy w-full bg-transparent border-0 border-b border-stone-300 py-3 text-lg focus:border-terracotta"
          />
        </Field>
      </div>
      <Field label="City" testid="dc-city">
        <input
          data-testid="dc-input-city"
          name="city" value={form.city} onChange={onChange}
          placeholder="e.g., Delhi, Mumbai"
          className="input-airy w-full bg-transparent border-0 border-b border-stone-300 py-3 text-lg focus:border-terracotta"
        />
      </Field>
      <Field label="Tell me about your requirements" testid="dc-requirements">
        <textarea
          data-testid="dc-input-requirements"
          name="requirements" value={form.requirements} onChange={onChange}
          rows={4}
          placeholder="Taxes, audits, advisory, due diligence..."
          className="input-airy w-full bg-transparent border-0 border-b border-stone-300 py-3 text-lg resize-none focus:border-terracotta"
        />
      </Field>

      <button
        type="submit"
        disabled={loading}
        data-testid="dc-submit"
        className="inline-flex items-center justify-center rounded-full bg-ink text-white px-8 py-4 font-semibold hover:bg-terracotta transition-colors disabled:opacity-60"
      >
        {loading ? "Sending..." : "Request a Discovery Call"}
        <span aria-hidden className="ml-2">→</span>
      </button>
    </form>
  );
}

function Field({ label, testid, children }) {
  return (
    <label data-testid={`field-${testid}`} className="block">
      <span className="overline">{label}</span>
      <div className="mt-2">{children}</div>
    </label>
  );
}
